<form [formGroup]="form">
  <mat-card class="column comparison-card">
    <mat-card-header>
      <mat-card-title><img src="icons/id_card.svg" /> Contact Info</mat-card-title>
    </mat-card-header>
    <mat-card-content>
      <div class="row">
        <mat-form-field appearance="outline" class="column">
          <mat-label>Business Legal Name</mat-label>
          <input matInput formControlName="businessLegalName">
        </mat-form-field>
      </div>
      <div class="row">
        <mat-form-field appearance="outline" class="column">
          <mat-label>Business DBA Name</mat-label>
          <input matInput formControlName="businessDbaName">
        </mat-form-field>
      </div>
      <div class="row">
        <mat-form-field appearance="outline" class="column">
          <mat-label>Website URL</mat-label>
          <input matInput formControlName="webSiteUrl">
        </mat-form-field>
      </div>
    </mat-card-content>
  </mat-card>

</form>

